import { useEffect, useState } from "react"

export const useLocalStorage = <T>(
  key: string, 
  initialValue: T,
  isValueValid?: (value: T) => boolean,  
  dependencies: any[] = []
): [T, React.Dispatch<React.SetStateAction<T>>, () => void] => {

  const initialState = () => {
    try {
      const storedValue = localStorage.getItem(key)
      if (!storedValue || storedValue === "undefined") return initialValue
      
      const parsedValue = JSON.parse(storedValue)
      if (isValueValid && !isValueValid(parsedValue)) {
        console.warn(`Invalid value "${storedValue}" found in localStorage for key "${key}", using initial value ${JSON.stringify(initialValue)}`)
        return initialValue
      }
      
      return parsedValue as T
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error)
      return initialValue
    }
  }

  const [state, setState] = useState<T>(initialState)
  const clear = () => {
    localStorage.removeItem(key)
    setState(initialValue)
  }

  useEffect(() => { setState(initialState()) }, [key, ...dependencies])

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(state))
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error)
    }
  }, [state])

  return [state, setState, clear]
}